import { TopicData } from '~/types/theory'

import Schema from './Schema'

interface Props {
  breadcrumbs: TopicData[]
}

function createSchemaObject(breadcrumbs: TopicData[]): any {
  const createItem = (path: string): string => `https://www.houseofmath.com${path}`
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.h1,
        item: createItem(breadcrumb.path),
      }
    }),
  }
}

const BreadcrumbSchema = ({ breadcrumbs }: Props): React.ReactElement => {
  const schemaObject = createSchemaObject(breadcrumbs)

  return <Schema schemaObject={schemaObject} />
}

export default BreadcrumbSchema
